import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DateRangeValue } from '@shared/form-fields/date-range/date-range.value';

@Component({
    selector: 'app-date-range',
    templateUrl: './date-range.component.html',
    styleUrls: ['./date-range.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateRangeComponent {
    @Input() dateRange: DateRangeValue;

}
